import type { ReactNode } from 'react';
import { ErroFormacao } from '@/components/formacao/avisos-formacao';

export interface BlocoProps {
  /** Resultado de uma consulta (TanStack Query) ja reduzido ao que o bloco precisa. */
  carregando: boolean;
  erro: unknown;
  temDados: boolean;
  vazio: boolean;
  /** Texto do estado vazio: explica por que nao ha o que mostrar. */
  mensagemVazia: ReactNode;
  textoCarregando: string;
  onTentar: () => void;
  children: ReactNode;
}

/** Estados explicitos de um bloco que depende da API: carregando, erro (com tentar de novo), vazio e conteudo. */
export function Bloco({ carregando, erro, temDados, vazio, mensagemVazia, textoCarregando, onTentar, children }: BlocoProps) {
  if (erro && !temDados) return <ErroFormacao erro={erro} onTentar={onTentar} titulo="Não foi possível carregar este bloco" />;
  if (!temDados) return <p role="status" className="py-8 text-center text-small text-ink-muted">{carregando ? textoCarregando : 'Sem dados.'}</p>;
  if (vazio) return <p role="status" className="py-8 text-center text-small text-ink-muted">{mensagemVazia}</p>;
  return <>{children}</>;
}
